<template>
  <div class="outer">
    <div class="action-bar row">
      <div class="col-11 col-sm-6 col-md-8" style="padding-left:1.5em;">
        <b>Sort By:</b> &nbsp;
        <a href="#" @click="localSortByTitle">Name</a> &nbsp; | &nbsp;
        <a href="#" @click="localSortByVotes">Votes</a> &nbsp; | &nbsp;
        <a href="#" @click="localSortByLocation">Proxmity</a>
      </div>
    <div class="col-8 col-sm-4" style="padding-left:1.5em;">
      <b>Musical Only:</b>&nbsp;
      <toggle-button @change="onMusical" :value = "getMusicalOnly"/>
    </div>
    </div>
    <b-container
      no-gutters
      v-for="disp in allDisplays"
      v-bind:key="disp.displayid"
      class="display-row"
    >
      <OneDisplay v-bind:disp="disp" />
    </b-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import OneDisplay from "./OneDisplay.vue";

export default {
  name: "DisplayList",
  components: {
    OneDisplay
  },
  methods: {
    ...mapActions([
      "fetchState",
      "sortByTitle",
      "sortByVotes",
      "sortByLocation",
      "setMusicalOnly"
    ]),
    localSortByTitle() {
      this.$ga.event("sort", "title", "title", 123);
      this.sortByTitle();
    },
    localSortByVotes() {
      this.$ga.event("sort", "votes", "votes", 123);
      this.sortByVotes();
    },
    localSortByLocation() {
      this.$ga.event("sort", "location", "location", 123);
      this.sortByLocation();
    },
    onMusical(e) { 
      this.$ga.event("Filter", "Musical", e.value, 123);
      this.setMusicalOnly(e.value);
    }
  },
  computed: {
    ...mapGetters(["allDisplays", "getMusicalOnly"])
  },
  created() {
    this.fetchState();
  }
};
</script>

<style scoped>
.cool-title {
  font-size: 1.2em;
  text-decoration: underline;
  margin-top: 0px;
  margin-bottom: 0px;
  display: inline;
}

.cool-description {
  line-height: 1em;
  text-align: left;
  margin-left: 0.5em;
}

.action-bar {
  margin-bottom: 2em;
}
.votes {
  color: green;
  font-style: italic;
  font-size: 0.8em;
}
.distance {
  margin-left: 0.3em;
  color: darkred;
  font-style: italic;
  font-size: 0.8em;
}

.display-row {
  padding-bottom: 0.4em;
}
</style>
